<template>
  <div class="jps-curlist-description-view">
    <dl v-for="item in items" :key="item.key">
      <template v-if="!item.readNext">
        <dt class="has-text-weight-bold">
          <UiButtonIcon
            tag="button"
            v-if="editable"
            class="jps-icon-button list-delete"
            @click.stop="emits('delete-item', item)"
            icon="mdi/close-circle"
          />
          <BaseLink
            v-bind="baseLinkProps(item)"
            @click="emits('show-modal', item)"
          >
            {{ ls(item.title) }}
            <ListEditIcon :item="item" field="title" :editstate="editstate" />
            <ListEditIcon :item="item" field="url" :editstate="editstate" />
            <ListEditIcon :item="item" field="linkUrl" :editstate="editstate" />
          </BaseLink>
        </dt>
        <dd class="jps-attr is-size-7">
          <span v-if="!isEmpty(item.contributor)">{{
            ljoin(item.contributor)
          }}</span>
          <template v-if="item.type === 'item' && item.data">
            <span v-if="isJps && item.data.common.provider"
              >{{ item.data.common.provider }}/</span
            >
            <UiDbSpan :id="item.data.common.database" />
          </template>
          <template v-else-if="isJps">
            <UiOrgSpan v-if="item.ownerOrgId" :id="item.ownerOrgId" />
          </template>
        </dd>
        <dd class="jps-desc">
          {{ ls(item.description) }}
          <ListEditIcon :item="item" field="description" :editstate="editstate" />
        </dd>
      </template>
      <template v-else>
        <SearchResultDiv :item="item" :editstate="editstate" /></template>
    </dl>
    <div class="list-add-div" v-if="editable && !isNote">
      <button
        class="jps-icon-button list-add-button jps-sub-orange"
        @click="emits('add')"
      >
        <BaseIcon name="mdi/plus-circle" :alt="ls(addPartMsg)" size="size-4" />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { ls, ljoin } = useI18n()
const { isJps } = useServiceType()

interface Props {
  editstate?: CurationEditState
  def : PartList
  items: ListElement[]
}
const props = withDefaults(defineProps<Props>(), {})

const emits = defineEmits(['delete-item', 'show-modal', 'add'])

const {
  isNote,
  hasExternalLink,
  baseLinkProps,
  editable,
  addPartMsg,
} = useCurationListView(props.editstate, props.def)
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-curlist-description-view {
  dl {
    dt {
      position: relative;
      .list-delete {
        position: absolute;
        right: 0px;
        top: 0px;
        background: $jps-gray-50;
      }
    }
    margin-bottom: 2rem;
    .jps-attr {
      @include typo-figcaption();
    }
    .jps-desc {
      margin-top: 0.5rem;
      margin-left: 2rem;
    }
  }
  .list-add-div {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
  }
}
</style>
